export default "__VITE_ASSET__WOhI6PaO__"